import { PatentOrderingKey } from "../../../Patent.types";

export const EMPTY_SHELL_VALUE = "-";

export type Ordering = "none" | "asc" | "desc";

export const ORDERING_TABLE = {
  asc: "desc",
  desc: "none",
  none: "asc",
} as const;

export interface TableHeaderList {
  title: string;
  orderingTitle: PatentOrderingKey;
  ordering: Ordering;
}
export const TABLE_HEADER_LIST: TableHeaderList[] = [
  { title: "ID", orderingTitle: "id", ordering: "none" },
  {
    title: "Publication\nNumber",
    orderingTitle: "publicationNumber",
    ordering: "none",
  },
  {
    title: "Publication\nCountry",
    orderingTitle: "publicationCountry",
    ordering: "none",
  },
  {
    title: "Publication\nDate",
    orderingTitle: "publicationDate",
    ordering: "none",
  },
  {
    title: "Application\nDate",
    orderingTitle: "applicationDate",
    ordering: "none",
  },
  {
    title: "Applicant\nName",
    orderingTitle: "applicantName",
    ordering: "none",
  },
  {
    title: "Assignee\nName",
    orderingTitle: "assigneeName",
    ordering: "none",
  },
  { title: "Unsuitable", orderingTitle: "unsuitable", ordering: "none" },
  { title: "Title", orderingTitle: "title", ordering: "none" },
  {
    title: "Primary\nCategory",
    orderingTitle: "primaryCategory",
    ordering: "none",
  },
  { title: "Status", orderingTitle: "status", ordering: "none" },
  { title: "Start Date", orderingTitle: "startDate", ordering: "none" },
  { title: "Complete\nDate", orderingTitle: "completeDate", ordering: "none" },
  { title: "MC\nEditor", orderingTitle: "mcEditorName", ordering: "none" },
  { title: "FT\nEditor", orderingTitle: "ftEditorName", ordering: "none" },
];
